export const style = {
  boxContainer: {
    sx: {
      maxWidth: 'lg',
      mt: 3,
    },
  },
  innerBoxContainer: {
    sx: {
      backgroundColor: 'white',
      py: 4,
      px: 3,
      borderRadius: 1,
      mb: 3,
    },
  },
  typography: {
    variant: 'h6',
    sx: {
      color: 'primary.text',
    },
  },
  boxTitle: {
    sx: {
      marginBottom: '24px',
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  IconWrapper: {
    sx: {
      '.MuiButton-startIcon': {
        margin: 0,
      },
      '& .MuiSvgIcon-root': {
        color: 'action.active',
      },
    },
  },
} as const;
